export type TenantLoginProviderType = (typeof TenantLoginProviderType)[keyof typeof TenantLoginProviderType];

export const TenantLoginProviderType = {
    Local: 'Local',
    AzureAD: 'AzureAD',
} as const;
